(function(){

	var MovieClip = include('createjs.MovieClip');
	var plugin = new springroll.ApplicationPlugin();

	plugin.setup = function()
	{
		MovieClip.prototype.gotoAndPlayThenStop = function(label, callback) {
			if (typeof callback !== "function") {
				callback = function(){};
			}

			// Clear other listeners, and start playing
			this._unbindSegment();
			this.gotoAndPlay(label);

			// Get the index of our label
			var index = this._getLabelIndex(label);

			// Index should always be greater than 0, unless the label passed in doesn't exist on the clip
			if (index < 0){
				console.error(label + " isn't a label on this clip!");
			} else {
				// Check every tick to see if we haven't moved onto a different label
				this._playSegment(index, label, callback, false);
			}
		};

		MovieClip.prototype.gotoAndLoop = function(label, callback) {
			if (typeof callback !== "function") {
				callback = function(){};
			}

			// Clear other listeners, and start playing
			this._unbindSegment();
			this.gotoAndPlay(label);

			// Get the index of our label
			var index = this._getLabelIndex(label);

			// Index should always be greater than 0, unless the label passed in doesn't exist on the clip
			if (index < 0){
				console.error(label + " isn't a label on this clip!");
			} else {
				// Check every tick to see if we haven't moved onto a different label
				this._playSegment(index, label, callback, true);
			}
		};

		MovieClip.prototype.stopLoop = function() {
			this._unbindSegment();
			this.stop();
		};

		MovieClip.prototype._playSegment = function(index, label, callback, loop) {
			if (typeof loop === "undefined") {
				loop = false;
			}

			this.extensionTickHandler = this.on('tick', function(e){

				if (!(this.currentLabel !== label || this.paused || (this.currentFrame === this.timeline.duration && this.loop === false))) {
					return;
				}
				// Either we're on a new label or the clip ended

				if (loop === true) {
					// execute callback for loop
					this.gotoAndPlay(label);
					callback();
					return;
				}

				// The frame to stop on
				var frame = this.currentFrame;

				// If there is another label after this one, set the index to that label and use the frame before that one started
				if (index < this.labels.length - 1){
					index++;
					frame = this.labels[index].position - 1;
				}
				// Otherwise, use the last frame
				else {
					frame = this.duration - 1;
				}

				// Stop the clip on the last frame of the label
				this.gotoAndStop(frame);
				// Unbind the event
				this._unbindSegment();

				// execute callback
				callback();
			});
		};

		MovieClip.prototype._unbindSegment = function() {
			this.off('tick', this.extensionTickHandler);
		};

		MovieClip.prototype._getLabelIndex = function(label) {
			var index = -1;
			for (var i = 0; i < this.labels.length; i++){
				var l = this.labels[i];
				if (l.label === label){
					index = i;
					break;
				}
			}
			return index;
		};
	};

	plugin.teardown = function()
	{

	};

})();